import { render } from "./TargetSelectPostDialog.vue?vue&type=template&id=749874aa"
import script from "./TargetSelectPostDialog.vue?vue&type=script&lang=js"
export * from "./TargetSelectPostDialog.vue?vue&type=script&lang=js"

import "./TargetSelectPostDialog.vue?vue&type=style&index=0&id=749874aa&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__